import certificate from '@/api/academic/certificate';

import { baseState, baseMutations } from '@/store/mixins';

export const state = {
    ...baseState,
}

export const getters = {}

export const mutations = {
    ...baseMutations,
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search,
                }
            },
            attrubutes
        )
        return certificate.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return certificate.store(data)
    },
    update(context, { id, data }) {
        return certificate.update(id, data)
    },
}
